import { css } from 'lit';

var css_248z = css`slot[name=separator]::slotted(*){align-items:center;display:inline-block;padding-left:.25rem;padding-right:.5rem}:host(:last-of-type) .breadcrumb-item__separator{display:none}`;

export { css_248z as default };
//# sourceMappingURL=sgds-breadcrumb2.js.map
